import Kendra from 'aws-sdk/clients/kendra';

export enum DocumentAttributeKeys {
    Category = '_category',
    CreatedAt = '_created_at',
    DataSourceId = '_data_source_id',
    DocumentTitle = '_document_title',
    Format = '_file_type',
    SourceUri = '_source_uri',
    UpdatedAt = '_last_updated_at',
    Version = '_version',
    ViewCount = '_view_count',
}

export const DocumentAttributeTitleLookup: { [key: string]: string } = {
    [DocumentAttributeKeys.Category]: 'Category',
    [DocumentAttributeKeys.CreatedAt]: 'Created at',
    [DocumentAttributeKeys.DataSourceId]: 'Data source',
    [DocumentAttributeKeys.DocumentTitle]: 'Title',
    [DocumentAttributeKeys.Format]: 'File type',
    [DocumentAttributeKeys.SourceUri]: 'Source URI',
    [DocumentAttributeKeys.UpdatedAt]: 'Updated at',
    [DocumentAttributeKeys.Version]: 'Version',
    [DocumentAttributeKeys.ViewCount]: 'View count',
    documentName: 'Document Name',
};

export enum QuerySuggestionsMode {
    ENABLED = 'ENABLED',
    LEARN_ONLY = 'LEARN_ONLY',
}

export const PAGE_SIZE = 10;

export type AttributeMap = {
    [key in DocumentAttributeKeys]: Kendra.DocumentAttributeValue;
};

export enum QueryResultType {
    All = 'ALL',
    Answer = 'ANSWER',
    QuestionAnswer = 'QUESTION_ANSWER',
    Document = 'DOCUMENT',
}
